import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Alert from '@material-ui/lab/Alert';

export const AlertMargin = styled(Alert)`
  margin-bottom: 1em;
`;

export const TextFieldMargin = styled(TextField)`
  margin-bottom: 1em;
`;
